import Content from './Content';
import Favorites from '../favorites/Favorites';
import React from 'react';

function Widget() {
    return (
        <React.Fragment>
        <Favorites/>
        <Content/>
        </React.Fragment>
    );
}

export default Widget;
